var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<dt ng-if=\"annotations\" translate>Annotations</dt> <dd ng-repeat=\"(name, value) in annotations\">{{name}}: {{value}}</dd>";
ngModule.run(["$templateCache",function(c){c.put("registry-image-widgets/views/annotations.html",v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./views/annotations.html
// module id = 6
// module chunks = 0